import { useCallback, useMemo } from "react";

import { deleteData } from "@api/crud";
import { bffEndpoints } from "@api/Endpoints";

export function useInvalidateToken() {
  const invalidateToken = useCallback(async () => {
    const url = bffEndpoints.invalidateToken;
    const result = await deleteData(url);
    return result;
  }, []);

  return useMemo(
    () => ({
      invalidateToken
    }),
    [invalidateToken]
  );
}
